<template>
  <div id="ModalTask" class="px-2">
    <div class="row d-none" dir="rtl" style="direction: rtl !important">
      <div class="col-md-3 col-12">
        <date-picker color="dimgray" v-model="tarixAz" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
      </div>
      <div class="col-md-3 col-12">
        <date-picker color="dimgray" v-model="tarixTa" clearable :editable="true" placeholder=" تا تاریخ "></date-picker>
      </div>
      <div class="col-md-4 col-12" dir="ltr">
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-radio-group id="btn-radios-2" v-model="selected" :options="options" :aria-describedby="ariaDescribedby" button-variant="outline-info" size="sm" name="radio-btn-outline" buttons @change="ChangRadio(selected)"> </b-form-radio-group>
        </b-form-group>
      </div>
      <div class="col-md-2 col-12">
        <button class="btn btn-success mt-4 float-left" dir="ltr" @click.prevent="Search(selected, false)"><span> جستجو </span><span class="fas fa-search"></span></button>
      </div>
    </div>
    <BnpGrid v-if="$store.state.renderComponentGrid" :propsColumn="$store.state.columns" :propsRows="rowsRiz" :action="true" :hasRowNum="true" :Sortable="true">
      <template slot="action-slot" slot-scope="props">
        <button v-if="!props.props.Done" class="btn btn-lg text-success" @click="DoneTask(props.props)" title="انجام شد"><i class="fad fa-user-check"></i></button>
        <a href="javascript:;" class="mr-2 badge" @click="OnEditNew(props.props)" title="مشاهده"
          ><h6><span v-if="props.props.IsView == false" class="fas fa-eye font-weight-bold hover-danger"></span><span v-else class="fas fa-check-double font-weight-bold hover-info"></span></h6
        ></a>
        <button v-if="!props.props.Done" class="btn btn-lg text-info" @click="Donereply(props.props)" title="کپی"><i class="fad fa-copy"></i></button>
      </template>
      <template slot="CustomerCode" slot-scope="props">
        <a href="javascript:;" @click="OnDetail(props.props)">{{ props.props.CustomerCode }}</a>
      </template>
      <template slot="CodeBazaryabi" slot-scope="props">
        <a href="javascript:;" @click="OnDetail(props.props)">{{ props.props.CodeBazaryabi }}</a>
      </template>
    </BnpGrid>
  </div>
</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  components: { Card, BnpGrid, datePicker: VuePersianDatetimePicker },
  data() {
    return {
      loadingRender: false,
      tarixAz: null,
      tarixTa: this.$store.state.JalaliDate,
      dataFilter: [],
      selected: 'NoDone',
      options: [
        { text: 'انجام نشده', value: 'NoDone' },
        { text: 'انجام شده', value: 'Done' },
        { text: 'همه', value: 'All' },
      ],
      rowsRiz: [],
      ColumnRiz: [],
      DataAxoisRiz: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmTask',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxios_GetdatRiz: { ArryfildValue: {} },
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      infoTaskStatus: {},
    }
  },
  beforeMount() {
    this.$GetColumns(this.DataAxoisRiz, true)
      .then((data) => {
        // this.ColumnRiz = data
        this.$store.state.columns = data
      })
      .finally(() => {
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
      })
  },
  mounted(selected) {
    if (selected == undefined) {
      selected = 'NoDone'
    }
    this.Search(selected, false)
  },
  methods: {
    DoneTask(row) {
      this.$SweetQustion('اطمینان از تایید', ' از انجام شده این کار اطمینان دارید؟', 'info', 'بلـــه', 'خیر', row, this.DoneT, this.cancel)
    },
    DoneT(row) {
      if (row.IsReply) {
        const swalWithBootstrapButtons = this.$swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success mx-1',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })
        swalWithBootstrapButtons
          .fire({
            title: 'این کـار نیاز به پاسخ دارد ',
            text: '',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'پاسخ',
            cancelButtonText: 'انصراف',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$store.state.OldDataForLog = JSON.stringify(row)
              row.Done = true
              row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
              row.IsView = true
              this.DataAxiosUpdate.Action = 'Task'
              this.DataAxiosUpdate.ArryfildValue = row
              this.$PutData_Body(this.DataAxiosUpdate)
                .then((data) => {
                  if (data.status == 'Ok') {
                    this.$SetLog(row, 0, 1)
                    this.infoTaskStatus = data.taskStatus
                  } else {
                    this.$toasted.error('مشکل در بروزرسانی فعالیت لطفا مجدد تلاش کنید', {
                      action: {
                        text: 'بستن',
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0)
                        },
                      },
                    })
                  }
                })
                .finally(() => {
                  this.$router.push({ name: 'ReplyTask', params: { Status: 'Add', TaskStatus: this.infoTaskStatus } })
                })
            }
          })
      } else {
        this.$store.state.OldDataForLog = JSON.stringify(row)
        row.Done = true
        row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
        row.IsView = true
        this.DataAxiosUpdate.Action = 'Task'
        this.DataAxiosUpdate.ArryfildValue = row
        this.$PutData_Body(this.DataAxiosUpdate)
          .then((data) => {
            if (data.status == 'Ok') {
              this.$SetLog(row, 0, 1)
              this.$toasted.success('فعالیت با موفقیت انجام شد', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  },
                },
              })
            } else {
              this.$toasted.error('مشکل در بروزرسانی فعالیت لطفا مجدد تلاش کنید', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  },
                },
              })
            }
          })
          .finally(() => {
            this.Search(this.selected, false)
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
      }
    },
    Donereply(row) {
      this.$router.push({ name: 'DetailTask', params: { Status: 'Add', DataRow: row } })
    },
    OnEditNew(row) {
      if (row.IsView == true) {
        this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row } })
      } else {
        this.$store.state.OldDataForLog = JSON.stringify(row)
        row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
        row.IsView = true
        this.DataAxiosUpdate.Action = 'Task'
        this.DataAxiosUpdate.ArryfildValue = row
        this.$PutData_Body(this.DataAxiosUpdate)
          .then((data) => {
            if (data.status == 'Ok') {
              row.DateView = data.taskStatus.dateView
              this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row } })
            } else {
              this.$toasted.error('مشکل در بروزرسانی فعالیت لطفا مجدد تلاش کنید', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(10000)
                  },
                },
              })
            }
          })
          .finally(() => {})
      }
    },
    ChangRadio(data) {
      this.Search(data, false)
      this.rowsRiz = []
    },
    Search(selected, okSearch) {
      this.rowsRiz = []
      this.loadingRender = true
      // if (this.dataFilter.length > 0 && okSearch == true) {
      //   switch (selected) {
      //     case 'NoDone':
      //       this.rowsRiz = []
      //       Filter = this.dataFilter.filter((x) => x.Done == false)
      //       break
      //     case 'Done':
      //       this.rowsRiz = []
      //       Filter = this.dataFilter.filter((x) => x.Done == true)
      //       break
      //     case 'All':
      //       this.rowsRiz = []
      //       Filter = this.dataFilter.filter((x) => x.Done == true || x.Done == false)
      //       break
      //     default:
      //       break
      //   }
      //   if (Filter.length > 0) {
      //     for (let index = 0; index < Filter.length; index++) {
      //       this.rowsRiz.push(Filter[index])
      //     }
      //   } else {
      //     console.log('No Data')
      //   }
      //   this.$store.state.renderComponentGrid = false
      //   this.$nextTick(() => {
      //     this.$store.state.renderComponentGrid = true
      //   })
      //   this.loadingRender = false
      // } else {
      this.loadingRender = true
      this.DataAxios_GetdatRiz.Action = 'Task/Index'
      this.DataAxios_GetdatRiz.ArryfildValue.tblUserId = this.$session.get('UserInfo').tblUserId
      this.DataAxios_GetdatRiz.ArryfildValue.TaskDateAz = this.tarixAz
      this.DataAxios_GetdatRiz.ArryfildValue.TaskDateTa = this.tarixTa
      this.DataAxios_GetdatRiz.ArryfildValue.Done = selected
      this.DataAxios_GetdatRiz.Method = 'Post'
      this.DataAxios_GetdatRiz.Token = this.$session.get('Token')
      this.$PostData(this.DataAxios_GetdatRiz)
        .then((data) => {
          this.dataFilter = data
          // switch (selected) {
          //   case 'NoDone':
          //     this.rowsRiz = []
          //     Filter = this.dataFilter.filter((x) => x.Done == false)
          //     break
          //   case 'Done':
          //     this.rowsRiz = []
          //     Filter = this.dataFilter.filter((x) => x.Done == true)
          //     break
          //   case 'All':
          //     this.rowsRiz = []
          //     Filter = this.dataFilter.filter((x) => x.Done == true || x.Done == false)
          //     break
          //   default:
          //     break
          // }
          if (this.dataFilter.length > 0) {
            this.loadingRender = false
            for (let index = 0; index < this.dataFilter.length; index++) {
              this.rowsRiz.push(this.dataFilter[index])
            }
          } else {
            this.loadingRender = false
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    OnDetail(data) {
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.TblCustomerId } })
      this.$FindeCustomerById('DetailCustomer', data.TblCustomerId, false, null)
    },
  },
}
</script>
<style>
.toasted-container {
  position: fixed;
  z-index: 10000;
  direction: rtl;
}
.toasted-container .toasted .action {
  text-decoration: none;
  font-size: 0.9rem !important;
  padding: 10px !important;
  margin: 5px 7px 5px -7px !important;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 600;
  cursor: pointer;
}
.legend {
  border-bottom: none !important;
}
/* #ModalTask table{
    font-size: x-small;
} */
</style>
